import React from 'react';
import { QuickReplyOption, quickReplyDisplayLabels } from './quickReplyUtils';

const QUICK_REPLY_ARRAY_PATTERN = /(?:Buttons?:\s*)?\[["'][^"']+["'](?:\s*,\s*["'][^"']+["'])*\]\s*/gi;

export function stripQuickReplyArtifacts(content: string, quickReplies?: Array<string | QuickReplyOption>): string {
  if (!content) return content;

  let cleaned = content;
  const labels = quickReplyDisplayLabels(quickReplies);
  if (labels.length) {
    cleaned = cleaned.replace(JSON.stringify(labels), '');
    cleaned = cleaned.replace(JSON.stringify(quickReplies), '');
  }
  cleaned = cleaned.replace(QUICK_REPLY_ARRAY_PATTERN, '');
  cleaned = cleaned.replace(/\n\s*Buttons?:\s*$/i, '');
  return cleaned.trimEnd();
}

const BOLD_PATTERN = /(\*\*[^*]+\*\*)/g;

function renderBoldSegments(line: string): React.ReactNode[] {
  return line.split(BOLD_PATTERN).map((segment, index) => {
    if (segment.startsWith('**') && segment.endsWith('**')) {
      return <strong key={index}>{segment.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={index}>{segment}</React.Fragment>;
  });
}

interface AgentMessageContentProps {
  content: string;
  quickReplies?: Array<string | QuickReplyOption>;
}

/**
 * Render lightweight assistant markdown (bold + line breaks) in chat bubbles.
 */
export default function AgentMessageContent({ content, quickReplies }: AgentMessageContentProps) {
  const displayContent = stripQuickReplyArtifacts(content, quickReplies);
  const lines = displayContent.split('\n');

  return (
    <>
      {lines.map((line, lineIndex) => (
        <React.Fragment key={lineIndex}>
          {lineIndex > 0 && <br />}
          {renderBoldSegments(line)}
        </React.Fragment>
      ))}
    </>
  );
}
